import type { ResumeDto } from "@reactive-resume/dto";

export type SaveStatus = "idle" | "error";

export const createResumeSaver = (options: {
  delayMs: number;
  save: (resume: ResumeDto) => Promise<unknown>;
  onStatus: (status: SaveStatus) => void;
}) => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let attempt = 0;

  return {
    schedule(resume: ResumeDto) {
      if (timer) clearTimeout(timer);
      const id = ++attempt;

      timer = setTimeout(() => {
        void options.save(resume).then(
          () => {
            if (id === attempt) options.onStatus("idle");
          },
          () => {
            if (id === attempt) options.onStatus("error");
          },
        );
      }, options.delayMs);
    },
  };
};
